import React, { useState } from "react"

import { A } from "../../../shared/utils/router"
import AccountDeletionFormStyles from "./account-deletion.module.css"
import FlexWrapper from "../../../shared/components/fields/flex-wrapper"
import IconAction from "../../../shared/components/universal/icon-action"
import Input from "../../../shared/components/fields/input"
import LinkButtonWrapper from "../universal/link-button-wrapper"
import ReactMarkdown from "react-markdown"
import Spacer from "../universal/spacer"
import Text from "../matrix/text"
import { toast } from "react-toastify/unstyled"
import { useForm } from "react-hook-form"
import { useMediaQuery } from "../../../hooks/use-media-query-admin"
import { useTranslation } from "react-i18next"

const AccountDeletionForm = () => {
    const { t } = useTranslation("translations")
    const [isSuccess, setIsSuccess] = useState(false)

    const { handleSubmit, control, reset } = useForm({
        mode: "onTouched",
        defaultValues: {
            firstname: "",
            lastname: "",
            email: "",
            customerNumber: "",
        },
        context: undefined,
        criteriaMode: "firstError",
        shouldFocusError: true,
    })

    const submit = async values => {
        const body = {
            name_first: values.firstname,
            name_last: values.lastname,
            mail_address: values.email,
            customer_number: +values.customerNumber,
        }

        try {
            const response = await fetch(process.env.API_URL_IO + "request", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            })
            if (!response.ok) {
                throw new Error("Error")
            }
            setIsSuccess(true)
            reset()
        } catch (error) {
            toast.error(t("account_deletion_form_error"))
        }
    }

    const isMobile = useMediaQuery("(max-width: 767px)", { initializeWithValue: false })

    return (
        <div className={AccountDeletionFormStyles.wrapper}>
            {!isSuccess ? (
                <form onSubmit={handleSubmit(submit)} name="account" className={AccountDeletionFormStyles.form}>
                    <h2>{t("account_deletion_form_headline")}</h2>
                    <FlexWrapper childWidths={isMobile ? [100, 100] : [50, 50]} wrap>
                        <Input
                            control={control}
                            rules={{ required: { value: true, message: t("form_error_required") } }}
                            type="text"
                            name="firstname"
                            label={t("account_deletion_firstname_label")}
                            autocomplete="given-name"
                            required
                        />
                        <Input
                            control={control}
                            rules={{ required: { value: true, message: t("form_error_required") } }}
                            type="text"
                            name="lastname"
                            label={t("account_deletion_lastname_label")}
                            autocomplete="family-name"
                            required
                        />
                    </FlexWrapper>
                    <FlexWrapper childWidths={isMobile ? [100, 100] : [50, 50]} wrap>
                        <Input
                            control={control}
                            rules={{ required: { value: true, message: t("form_error_required") } }}
                            type="email"
                            name="email"
                            label={t("account_deletion_email_label")}
                            autocomplete="email"
                            required
                        />
                        <Input
                            control={control}
                            rules={{ required: { value: false } }}
                            type="tel"
                            name="customerNumber"
                            label={t("account_deletion_customer_number_label")}
                        />
                    </FlexWrapper>
                    <div className={AccountDeletionFormStyles.smallprint}>
                        <ReactMarkdown
                            components={{
                                a: ({ children, href }) => <A href={href}>{children}</A>,
                            }}
                        >
                            {t("account_deletion_smallprint")}
                        </ReactMarkdown>
                    </div>
                    <p className={AccountDeletionFormStyles.asterisk}>
                        <span style={{ color: "#bf4751" }}>*</span> {t("form_required_field")}
                    </p>
                    <Spacer small />
                    <LinkButtonWrapper center>
                        <IconAction
                            title={t("account_deletion_submit")}
                            button
                            submit
                            variant={AccountDeletionFormStyles.button}
                        />
                    </LinkButtonWrapper>
                </form>
            ) : (
                <div className={AccountDeletionFormStyles.success}>
                    <div className={AccountDeletionFormStyles.circle}>
                        <i className="lavita-icon"></i>
                    </div>
                    <Spacer small />
                    <Text
                        small
                        source={t("account_deletion_form_success_text")}
                        align={{ desktop: "center", tablet: "center", mobile: "center" }}
                    />
                </div>
            )}
        </div>
    )
}

export default AccountDeletionForm
